import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["error"];

  connect() {
    this.currentMonth = parseInt(this.element.dataset.calendarMonth);
    this.currentYear = parseInt(this.element.dataset.calendarYear);

    this.clearError();
  }

  validateAndSubmit(event) {
    const data = new FormData(event.target);

    const date = data.get("selected_date");
    const time = data.get("selected_time");

    if (!date || !time) {
      event.preventDefault();
      this.showError("Please select both a date and a time before continuing.");
      return;
    }

    this.clearError();
  }

  showError(message) {
    if (!this.hasErrorTarget) return;
    this.errorTarget.textContent = message;
  }

  clearError() {
    if (!this.hasErrorTarget) return;
    this.errorTarget.textContent = "";
  }

  nextMonth() {
    this.currentMonth += 1;
    if (this.currentMonth > 12) {
      this.currentMonth = 1;
      this.currentYear += 1;
    }

    this.navigateCalendar();
  }

  previousMonth() {
    this.currentMonth -= 1;
    if (this.currentMonth < 1) {
      this.currentMonth = 12;
      this.currentYear -= 1;
    }

    this.navigateCalendar();
  }

  navigateCalendar() {
    const url = `/booking/calendar?month=${this.currentMonth}&year=${this.currentYear}`;

    Turbo.visit(url, { frame: "calendar-frame" });
  }
}
